export function activityLogData(state) {
  return state.activityLogData;
}
export function meta(state) {
  return state.meta;
}